import axios from "axios";
import router from "../router";
const instance = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: '/',
  timeout: 80000
});
// 设置请求次数，请求的间隙
instance.defaults.retry = 4;
instance.defaults.retryDelay = 1000;
function baseRequest(options) {
  const token ="";
  const headers = {};
  headers["X-token"] = token || "";
  options.headers = headers;
    return instance(options).then(res => {
    const data = res.data || {};
    if (res.status !== 200) {
        return Promise.reject({ message: "请求失败", res, data });

    }

    if (res.status === 200) {
      return Promise.resolve(data, res);
    } else {
        if (res.status === 400) {
        router.replace({ path: "/" });
       }
        return Promise.reject({ message: res.data.message , res, data });
    }
  }).catch((e) => {
    console.log(e);
    // return Promise.reject({ message: "请求失败", e });
    });
}

const request = ["post", "put", "patch"].reduce((request, method) => {
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(Object.assign({ url, data, method }, options));
    //console.log(c)
  };
  return request;
}, {});
["get", "delete", "head"].forEach(method => {
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(Object.assign({ url, params, method }, options));
  };
});
export default request;
